<template>
  <div class="card is-shadowless">
    <header class="card-header is-shadowless">
      <p class="card-header-title is-size-1">Operation mannager</p>
    </header>
    <div class="card-content">
      <div class="columns" v-for="(row, index) in rows" :key="index">
        <div class="column is-4" v-for="(item, index) in row" :key="index">
          <router-link
            v-if="item.route"
            :to="item.route"
            class="column button is-light p-1">{{ item.label }}</router-link>
          <a
            v-else-if="item.clickHandler"
            @click="clickHandler(item.clickHandler)"
            class="column button is-light p-1">{{ item.label }}</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'

export default {
  name: 'AdminPage',
  data () {
    return {
      rows: [
        [
          { route: { name: 'admin-alerts', query: { statuses: 'active', designators: 'designated_position', past: 'true', sort: '-priority' } }, label: 'משרות ייעודיות' },
          { route: { name: '' }, label: 'מדדים מאתמול' }
        ],
        [
          { route: { name: 'admin-alerts', query: { title: 'משימות שנדחו', statuses: 'irrelevant', past: 'true', sort: '-priority' } }, label: 'משימות שנדחו' },
          { route: { name: 'alerts-in-progress', query: { statuses: 'in_progress', sort: '-updated_at' } }, label: 'משימות בטיפול כעת' }
        ],
        [
          { route: { name: 'admin-offers', query: { statuses: 'interview,received_proposal', sort: '-sent_at' } }, label: 'תהליכים מתקדמים' },
          { route: { name: 'admin-alerts', query: { title: 'משרות שטופלו', designators: 'review_position,notice_position', statuses: 'active,in_progress', past: 'true', sort: '-created_at' } }, label: 'משרות שטופלו' }
        ],
        [
          { clickHandler: 'findNewCompanies', label: 'איתור מעסיקים חדשים' },
          { route: { name: 'admin-alerts', query: { title: 'צפי משימות', statuses: 'active', past: 'true', sort: '-priority' } }, label: 'צפי משימות' }
        ],
        [
          { route: { name: 'admin-designated-position' }, label: 'יצירת משרות ייעודיות' },
          { route: { name: 'time-exceeded', query: { sort: '-created_at' } }, label: 'חריגות זמנים' }
        ],
        [
          { route: { name: 'admin-alerts', query: { statuses: 'active', designators: 'follow_up_companies', sort: '-priority' } }, label: 'ניהול משימות מחזוריות' },
          { route: { name: 'employee-report', query: { date: this.$moment().format('YYYY-MM-DD') } }, label: 'דוח עובד' }
        ],
        [
          { clickHandler: 'createUniqueAlert', label: 'יצירת משימות ייחודיות' },
          { clickHandler: 'createFollowUpBackBackAlert', label: 'פולואפ אחורה- אחורה' }
        ],
        [
          { clickHandler: 'updateAllAlerts', label: 'Now all alerts' },
          { clickHandler: 'createDailyFollowUpAlert', label: 'יצירת משימת פולואפ יומן' }
        ]
      ]
    }
  },
  methods: {
    ...mapMutations('modals', ['create']),
    clickHandler (handle) {
      this[handle]()
    },
    createUniqueAlert () {
      this.create({ designator: 'alert-form-modal', component_name: 'AlertForm', init_priority: 50, is_create: true, modal_title: 'Create new Item' })
    },
    createFollowUpBackBackAlert () {
      this.create({ designator: 'alert-form-modal', component_name: 'AlertForm', init_priority: 95, minimum_permission: 1, maximum_permission: 9, initContent: 'יש לחזור חצי שנה אחורה ביומן הראיונות וליצור קשר עם המועמדים שרואיינו על מנת לוודא האם הייתה התקדמות', isNoOwner: true, is_create: true, modal_title: 'פולואפ אחורה- אחורה' })
    },
    createDailyFollowUpAlert () {
      this.create({ designator: 'alert-form-modal', component_name: 'AlertForm', init_priority: 95, minimum_permission: 1, maximum_permission: 9, initContent: 'יש לחזור חודש אחורה ביומן הראיונות וליצור קשר עם המועמדים שרואיינו על מנת לוודא התקדמות', isNoOwner: true, is_create: true, modal_title: 'פולואפ יומן חודש אחורה' })
    },
    updateAllAlerts () {
      this.$network_utils.massUpdateAlert({ id: '-1', now_all_alerts: 'true', owner: this.$utils.getOwner().name }).then(r => {
        this.$utils.emit('show_toast', { text: 'שונה בהצלחה' })
      })
    },
    findNewCompanies () {
      this.create({
        designator: 'alert-form-modal',
        component_name: 'AlertForm',
        is_create: true,
        init_designator: 'find_new_companies',
        initContent: 'איתור חברות חדשות',
        modal_title: 'Create new Alert'
      })
    }
  }
}
</script>
